import HistoricBondCreatePage from "./components/HistoricBondCreatePage";
import useProbateBondCreateHistoric from "./hooks/useProbateBondCreateHistoric";
import ProbateHistoricBasicInformation from "./components/ProbateHistoricBasicInformation";
import ProbateHistoricGuardianForm from "./components/ProbateHistoricGuardianForm";
import ProbateHistoricAttorneyInformation from "./components/ProbateHistoricAttorneyInformation";
import { ObligeeInformationForm } from "./Helpers/ObligeeInformation";
import ProbateHistoricRequestorInformation from "./components/ProbateHistoricRequestorInformation";
import { BillingInformationForm } from "./Helpers/BillingInformation";
import ProbateHistoricOtherDetails from "./components/ProbateHistoricOtherDetails";
import ProbateHistoricBondNumberSection from "./components/ProbateHistoricBondNumberSection";

const ProbateBondCreateHistoric = () => (
  <HistoricBondCreatePage
    bondKindLabel="Probate"
    useCreateHook={useProbateBondCreateHistoric}
    sections={[
      { key: "basic", Component: ProbateHistoricBasicInformation, stateKey: "basicInformation" },
      { key: "guardian", Component: ProbateHistoricGuardianForm, stateKey: "guardianDetails" },
      { key: "attorney", Component: ProbateHistoricAttorneyInformation, stateKey: "attorneyInformation" },
      { key: "obligee", Component: ObligeeInformationForm, stateKey: "obligeeInformation" },
      { key: "requestor", Component: ProbateHistoricRequestorInformation, stateKey: "requestorInformation" },
      { key: "billing", Component: BillingInformationForm, stateKey: "billingInformation" },
      { key: "other", Component: ProbateHistoricOtherDetails, stateKey: "otherDetails" },
      {
        key: "bondNumber",
        render: ({ globalState, updateGlobalState, errors }) => (
          <ProbateHistoricBondNumberSection
            data={globalState.otherDetails}
            updateData={(data) => updateGlobalState("otherDetails", data)}
            errors={errors}
          />
        ),
      },
    ]}
    submitDisabled={(globalState) => globalState?.basicInformation?.judgeStern === "No"}
  />
);

export default ProbateBondCreateHistoric;
